const TWO_PI = Math.PI * 2;
export function daysBetween(start, end) {
    const a = Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate());
    const b = Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate());
    return Math.round((b - a) / 86_400_000);
}
export function calcBiorhythms(birthDate, date = new Date()) {
    const birth = new Date(birthDate);
    const days = daysBetween(birth, date);
    return {
        physical: Math.sin((TWO_PI * days) / 23),
        emotional: Math.sin((TWO_PI * days) / 28),
        intellectual: Math.sin((TWO_PI * days) / 33),
    };
}
/**
 * Range of values centred on `centerDate`. Returns `radiusDays` values on
 * each side, so the total length is `radiusDays * 2 + 1`. Used to render
 * a "this month at a glance" line graph.
 */
export function calcBiorhythmsRange(birthDate, centerDate, radiusDays) {
    const out = [];
    for (let i = -radiusDays; i <= radiusDays; i++) {
        const d = new Date(centerDate.getTime() + i * 86_400_000);
        out.push({ date: d, values: calcBiorhythms(birthDate, d) });
    }
    return out;
}
//# sourceMappingURL=cycles.js.map